import { FETCH_APP_SETTINGS } from '../actions/AppConfigsActions';

const appSettingsReducer = (state = {}, action) => {
  switch (action.type) {
    case FETCH_APP_SETTINGS:
      return action.appSettings;

    default:
      return state;
  }
};

export default appSettingsReducer;
